var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F604(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD67",
    d: "M61.999 32c0 16.57-13.428 30-29.998 30C15.43 62 2 48.57 2 32 2 15.429 15.43 2 32.001 2c16.57 0 29.998 13.429 29.998 30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M49.001 38.049c0-.803-.475-1.807-1.822-2.066-3.464-.663-8.583-1.342-15.179-1.342h-.001c-6.595 0-11.714.68-15.177 1.342-1.35.259-1.822 1.263-1.822 2.066 0 7.271 5.611 14.592 16.999 14.592H32c11.389 0 17.001-7.321 17.001-14.592z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.526 26.854c-1.859-5.111-4.66-7.668-7.461-7.668s-5.602 2.558-7.46 7.668c-.184.516.774 1.443 1.254.939 1.802-1.902 3.957-2.659 6.206-2.659 2.25 0 4.405.757 6.207 2.659.478.504 1.437-.424 1.254-.939zM50.396 26.854c-1.859-5.111-4.66-7.668-7.462-7.668-2.801 0-5.602 2.558-7.461 7.668-.184.516.775 1.443 1.254.939 1.803-1.902 3.957-2.659 6.207-2.659 2.251 0 4.405.757 6.208 2.659.478.504 1.437-.424 1.254-.939z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M44.691 38.283C42.496 37.914 37.854 37.27 32 37.27c-5.853 0-10.496.645-12.691 1.014-1.294.217-1.373.742-1.283 1.486.054.441.137.975.265 1.552.142.64.262.936 1.266.816 1.92-.229 22.967-.229 24.887 0 1.005.119 1.124-.177 1.267-.816.127-.577.211-1.11.264-1.552.088-.745.01-1.27-1.284-1.487z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD67",
    d: "M61.999 32c0 16.57-13.428 30-29.998 30C15.43 62 2 48.57 2 32 2 15.429 15.43 2 32.001 2c16.57 0 29.998 13.429 29.998 30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M49.001 38.049c0-.803-.475-1.807-1.822-2.066-3.464-.663-8.583-1.342-15.179-1.342h-.001c-6.595 0-11.714.68-15.177 1.342-1.35.259-1.822 1.263-1.822 2.066 0 7.271 5.611 14.592 16.999 14.592H32c11.389 0 17.001-7.321 17.001-14.592z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.526 26.854c-1.859-5.111-4.66-7.668-7.461-7.668s-5.602 2.558-7.46 7.668c-.184.516.774 1.443 1.254.939 1.802-1.902 3.957-2.659 6.206-2.659 2.25 0 4.405.757 6.207 2.659.478.504 1.437-.424 1.254-.939zM50.396 26.854c-1.859-5.111-4.66-7.668-7.462-7.668-2.801 0-5.602 2.558-7.461 7.668-.184.516.775 1.443 1.254.939 1.803-1.902 3.957-2.659 6.207-2.659 2.251 0 4.405.757 6.208 2.659.478.504 1.437-.424 1.254-.939z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M44.691 38.283C42.496 37.914 37.854 37.27 32 37.27c-5.853 0-10.496.645-12.691 1.014-1.294.217-1.373.742-1.283 1.486.054.441.137.975.265 1.552.142.64.255.816 1.266.816h24.887c1.011 0 1.124-.177 1.267-.816.127-.577.211-1.11.264-1.552.088-.745.01-1.27-1.284-1.487z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F604);
export default __webpack_public_path__ + "static/media/1f604.2e9e4f060fd8f979a718ac22a4c225bf.svg";
export { ForwardRef as ReactComponent };